<template>
  <el-dialog custom-class="dialog-modal-permission" :model-value="flagVisible" width="770px" :before-close="handleClose">
    <div class="modal-permission">
      <div class="modal-p-content text-that-needs-wrapping">
        <div class="modal-p-title">
          <span>Discography is an essential feature!</span>
        </div>
        <div class="modal-p-desc">
          <p>Just like artists, engineers, and producers, your product has a <b>Discography</b>. Think of all the cool recordings it’s made. Wouldn’t you want to share that? This is often the social proof your customers are looking for.</p>
          <p>Contact <a href="mailto:sales@audiotestkitchen.com">sales@audiotestkitchen.com</a> to upgrade your subscription and share your product’s <b>Discography</b> with the world.</p>
        </div>
      </div>
      <div class="modal-p-img">
        <img src="@/assets/images/permissions/fea_disco.png" alt="" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal'],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
